/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
  parentForm: Object,
  model: Object,
  childmodel: Object,
  resetModels: Array,
  resetFields: Array,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class AddNewCompanySuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, accountStore }: TypeProps = this.props;

    if (typeof accountStore.locationLists[0] === 'string') {
      accountStore.locationLists[0] = [{ active: [] }];
    }

    accountStore.locationLists[0][0].active.push({
      locations_count: 0,
      ...actionDrawerStore.response,
    });

    actionDrawerStore.locationColumn = 1;
    actionDrawerStore.closeActionDrawer();
  }

  render() {
    return 'success';
  }
}
